import { SortPhotographersAPI } from "../../../../../utils/APIs/bookingsApis";
import {
    GetToFloatPhotographersgAPI,
    GetToFloatVideographersAPI,
    GetToFloatEditorAPI,
    GetToFloatLightingSetupAPI,
} from "../../../../../utils/APIs/hourlyAndEditingBookingsApis";

/** Role config for hourly / customize float accordions */
export const HOURLY_FLOAT_ROLES = [
    {
        key: "photographer",
        title: "Photographers",
        fetchListAPI: GetToFloatPhotographersgAPI,
        fetchAllAPI: GetToFloatPhotographersgAPI,
        fetchSortAPI: SortPhotographersAPI,
        showFilters: true,
    },
    {
        key: "videographer",
        title: "Videographers",
        fetchListAPI: GetToFloatVideographersAPI,
        fetchAllAPI: GetToFloatVideographersAPI,
        fetchSortAPI: null,
        showFilters: true,
    },
    {
        key: "editor",
        title: "Editors",
        fetchListAPI: GetToFloatEditorAPI,
        fetchAllAPI: GetToFloatEditorAPI,
        fetchSortAPI: null,
        showFilters: true,
    },
    {
        key: "lightingSetup",
        title: "Lighting Setup",
        fetchListAPI: GetToFloatLightingSetupAPI,
        fetchAllAPI: GetToFloatLightingSetupAPI,
        fetchSortAPI: null,
        showFilters: true,
    },
];

export const getHourlyFloatRoleByKey = (roleKey) =>
    HOURLY_FLOAT_ROLES.find((r) => r.key === roleKey) || HOURLY_FLOAT_ROLES[0];
